module.exports = __webpack_public_path__ + "img/c1b8efa.png";